import AdvisorTransportationPanelContainer from './AdvisorTransportationPanelContainer';

export default AdvisorTransportationPanelContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/AdvisorTransportationPanel/index.js